import { api } from "@/lib/api"
import { WorkspaceStackedBarChart } from "./workspace-stacked-bar-chart"

export function AIChatMessagesChart() {
	const query = api.analytics.aiChatMessagesChart.useQuery({})

	return (
		<WorkspaceStackedBarChart
			title="Productlane Agent messages"
			data={query.data}
			isLoading={query.isLoading}
		/>
	)
}
